import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg px-6 text-center">
      <div className="absolute top-8 left-8"><Logo /></div>
      <XCircle className="text-high mx-auto mb-5" size={40} />
      <h1 className="font-display text-2xl font-bold text-ink">Checkout canceled</h1>
      <p className="mt-3 text-muted max-w-sm">No charge was made. You can pick a plan whenever you're ready.</p>
      <div className="mt-6 flex gap-3">
        <Button onClick={() => navigate("/pricing")} className="bg-cyber text-[#0B0E14] font-semibold">View Plans</Button>
        <Button variant="outline" onClick={() => navigate("/dashboard")} className="border-line">Back to Console</Button>
      </div>
    </div>
  );
}
